module.exports = __webpack_public_path__ + "media/images/smart_phone/order_menu/txt_link-b0958c50041291a7d5e13e674077ee28.png";